import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { IslandQuestionReservationLocalPaymentCancelFee } from "./cancel-fee";
import { QuestionReservationDefaultIsLocalPaymentAvailable } from "./is-local-payment-available";

import type { HotelPolicyCategoriesAndManagerStore } from "../../../../store/categories";

type Props = {
	reservationLocalPaymentSettings: HotelPolicyCategoriesAndManagerStore["reservationLocalPaymentSettings"];
};

export const QuestionReservationLocalPaymentSettings = ({ reservationLocalPaymentSettings }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper categoryStore={reservationLocalPaymentSettings}>
				<QuestionReservationDefaultIsLocalPaymentAvailable />
			</FeatureIslandMainWithCategoryWrapper>

			<IslandQuestionReservationLocalPaymentCancelFee
				reservationLocalPaymentSettings={reservationLocalPaymentSettings}
			/>
		</>
	);
};

QuestionReservationLocalPaymentSettings.displayName = "QuestionReservationLocalPaymentSettings";
